import { UseMutateFunction } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { exportNetconfNetworkElements } from '@api/netconfEvents';

import { IVesEventsExportDTO } from '@interfaces/vesData/dto/vesEventsDTO';

import { ESnackbarTypes } from '@enums/common';

import { NETCONF_EVENTS_EXPORT } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export interface IUseMutateNetconfEventsExportReturned {
	exportNetconfEvents: UseMutateFunction<any, any, IVesEventsExportDTO, any>;
	isExportingNetconfEvents: boolean;
}

export const useMutateNetconfEventsExport = () => {
	const dispatch = useAppDispatch();

	const { mutate, isLoading } = useMutation<IVesEventsExportDTO>({
		mutationKey: [NETCONF_EVENTS_EXPORT],
		mutationFn: exportNetconfNetworkElements,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.exportStartingNotificationSuccess,
				type: ESnackbarTypes.success,
			}));
		},
	});

	return {
		exportNetconfEvents: mutate,
		isExportingNetconfEvents: isLoading,
	};
};
